import { useMemo } from 'react';
import { JSONContent } from '@tiptap/core';

import { getExtensions } from 'approot/shared/richtext/richtext.utils';
import { Field } from '../../response/response.constants';
import { getRichtextValue } from '../../shared/logic/get-richtext-value';
import { ResponseFieldReadonly } from '../../response/response-field-readonly.style';
import { NOTES_BASE_RICHTEXT_SETTINGS } from '../../teaching-notes/teaching-notes-richtext.constants';

const SuggestedAnswerResponseReadonly = ({
  field,
  baseHeight,
  answer,
}: {
  field: Field;
  baseHeight: number;
  answer: JSONContent | null | undefined;
}) => {
  const settings = useMemo(() => {
    return getExtensions(NOTES_BASE_RICHTEXT_SETTINGS);
  }, []);

  return (
    <ResponseFieldReadonly
      $baseHeight={baseHeight}
      $baseColour={field.baseColour}
      $numberOflines={field.numberOfLines || 1}
      dangerouslySetInnerHTML={{
        __html: getRichtextValue(answer, settings),
      }}
    />
  );
};

export default SuggestedAnswerResponseReadonly;
